import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {item.to ? (
            <Link
              to={item.to}
              className="text-foreground-500 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium whitespace-nowrap">
              {item.label}
            </span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          )}
        </span>
      ))}
    </nav>
  );
}